import { ExternalLink } from '@portal_components/components/ExternalLink';
import { FormButton } from '@portal_components/components/FormButton';
import { FormDropdown } from '@portal_components/components/FormDropdown';
import { FormTextArea } from '@portal_components/components/FormTextArea';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { Title } from '@portal_components/components/Title';
import { IndicatorType } from '@portal_components/components/WorkflowIndicator';
import { WorkflowNode } from '@portal_components/formWorkflow/FormWorkflowView';
import * as Yup from 'yup';

export const terminateJobBookingNode: WorkflowNode = {
  indicatorType: IndicatorType.Error,
  element: (
    <div>
      <Title text="Sorry, it appears that you may need a member of Stark to assist with this booking. Please use the following link to the Query Portal" className="mb-5 mt-7" />
      <ExternalLink link="https://starkenergyservices.atlassian.net/servicedesk/customer/portal/69" linkText="Stark Query Portal" />
    </div>
  )
};

export const siteContactDetailsNode: WorkflowNode<any> = {
  name: 'siteContactDetails',
  element: (
    <div>
      <Title text="Please confirm the site contact details" className="mb-5 mt-7" />
      <div className="w-[30em]">
        <FormDropdown
          name="siteContactDetails.title"
          title="Title"
          placeholder="Please select a title"
          mandatory
          elementsForDisplay={['Mx', 'Dr', 'Mr', 'Mrs', 'Ms', 'Miss', 'Prefer not to say'].map(title => ({ title, value: title }))}
          classProps="mb-1"
        />
        <FormTextInput name="siteContactDetails.contactFirstName" title="First Name" placeholder="Please enter a first name" mandatory />
        <FormTextInput name="siteContactDetails.contactSurname" title="Surname" placeholder="Please enter a valid contact surname" mandatory />
        <FormTextInput name="siteContactDetails.emailAddress" title="Email" placeholder="Please enter a valid email" />
        <FormTextInput name="siteContactDetails.contactNumber" title="Phone Number" placeholder="Please enter a valid contact number" mandatory />
        <FormTextInput name="siteContactDetails.secondaryContactNumber" title="Secondary Phone Number" placeholder="Please enter a valid secondary contact number" />
      </div>
    </div>
  ),
  validationSchema: {
    siteContactDetails: Yup.object({
      title: Yup.string().required('Please select a title'),
      contactFirstName: Yup.string().required('Please enter a first name').max(50, 'First name cannot exceed 50 characters'),
      contactSurname: Yup.string().required('Please enter a surname').max(50, 'Surname cannot exceed 50 characters'),
      emailAddress: Yup.string().optional().email('Please enter a valid email address'),
      contactNumber: Yup.string()
        .required('Please enter a contact number')
        .matches(/^0[12378]\d{8}\d?$/, 'Please enter a valid contact number'),
      secondaryContactNumber: Yup.string().matches(/^0[12378]\d{8}\d?$/, { message: 'Please enter a valid contact number', excludeEmptyString: true })
    }).required()
  }
};

export const siteAddressNode: WorkflowNode<any> = {
  name: 'siteAddress',
  element: (
    <div>
      <Title text="Please confirm the site address details" className="mb-5 mt-7" />
      <div className="w-[30em]">
        <FormTextInput name="siteAddress.addressName" title="Site Name" placeholder="Please enter a site name" mandatory />
        <FormTextInput name="siteAddress.addressLine1" title="Address Line 1" placeholder="Please enter address line 1" mandatory />
        <FormTextInput name="siteAddress.addressLine2" title="Address Line 2" placeholder="Please enter address line 2" />
        <FormTextInput name="siteAddress.addressLine3" title="Address Line 3" placeholder="Please enter address line 3" />
        <FormTextInput name="siteAddress.town" title="Town" placeholder="Please enter the town where the site is located" mandatory />
        <FormTextInput name="siteAddress.county" title="County" placeholder="Please enter the county where the site is located" mandatory />
        <FormTextInput name="siteAddress.postCode" title="Postcode" placeholder="Please enter a postcode" mandatory />
      </div>
    </div>
  ),
  validationSchema: {
    siteAddress: Yup.object({
      addressName: Yup.string().required('Please enter a site name').max(50, 'Site name cannot exceed 50 characters'),
      addressLine1: Yup.string().required('Please enter address line 1').max(50, 'Address line 1 cannot exceed 50 characters'),
      addressLine2: Yup.string().max(50, 'Address line 2 cannot exceed 50 characters'),
      addressLine3: Yup.string().max(50, 'Address line 3 cannot exceed 50 characters'),
      town: Yup.string().required('Please enter a town').max(50, 'Town cannot exceed 50 characters'),
      county: Yup.string().required('Please enter a county').max(50, 'County cannot exceed 50 characters'),
      postCode: Yup.string()
        .required('Please enter a postcode')
        .matches(/^[a-zA-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][a-zA-z]{2}$/, 'Invalid postcode')
    }).required()
  }
};

export const jobCommentsNode: WorkflowNode<any> = {
  name: 'jobComments',
  element: (
    <div>
      <Title text="Please enter any further information or instructions relating to this job" className="mb-5 mt-7" />
      <FormTextArea
        name="jobComments"
        title="Additional Comments"
        placeholder="Advise of any parking or access instructions/ restrictions, site directions, meter location information, health & safety concerns (e.g. face mask), and any other access information"
        mandatory
        className="w-[30em]"
      />
      <div className="mt-4">
        <FormButton type="submit" primary icon>
          Get Job Dates
        </FormButton>
      </div>
    </div>
  ),
  validationSchema: { jobComments: Yup.string().required('Please provide additional comments') }
};
